module.exports = flarum.reg.get('core', 'common/models/Discussion');